import React from "react";
import { BackgroundImage, ClinicImageSlider, TeethLogo } from "../../Components";

const Clinic = (props) => {
    const { selectedLanguage } = props
    return (
        <div className="main">
            <BackgroundImage heading={selectedLanguage?.txt_our_clinic} text={selectedLanguage?.txt_improve_your_smile_in_just_one_visit} mainClass='clinic-banner'/>
            <TeethLogo heading={selectedLanguage?.txt_our_clinic} text1={selectedLanguage?.txt_primadent_was_established_in_hurghada_in_2005_after} text2={selectedLanguage?.txt_our_object_is_to_offer_the_total_dental}/>
            <ClinicImageSlider/>
        </div>
    )
}

export default Clinic